import TimeInput, { ITimeInputProps } from 'components/molecules/TimeInput' // TODO: move the component code here

export default TimeInput

export { ITimeInputProps }
